import { PUBLISHER_API_URL } from '@/services/constants';
import axiosClient from '../axiosClient';

const PublisherPortal = {
  fetchPublisher: async (params: any) => {
    const response = await axiosClient.get(`${PUBLISHER_API_URL}`, {
      params
    });
    return response.data;
  },
  createPublisher: async (path: 'string', body: any) => {
    try {
      const response = await axiosClient.post(`${PUBLISHER_API_URL}/${path}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  deletePublisher: async (params: any) => {
    try {
      const response = await axiosClient.delete(`${PUBLISHER_API_URL}`, {
        params
      });
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  fetchApiDetails: async (id: any) => {
    try {
      const response = await axiosClient.get(`${PUBLISHER_API_URL}/${id}`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },

  updatePublisher: async (body: any, apiId: any) => {
    try {
      const response = await axiosClient.put(`${PUBLISHER_API_URL}/${apiId}`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  publishApi: async (body: any) => {
    try {
      const response = await axiosClient.post(`${PUBLISHER_API_URL}/change-lifecycle`, body);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  },
  downloadPublisher: async () => {
    try {
      const response = await axiosClient.get(`${PUBLISHER_API_URL}/download`);
      return response.data;
    } catch (err: any) {
      return err.response.data;
    }
  }
};

export default PublisherPortal;
